import React from 'react';
import RootControlCenter from './RootControlCenter';

// React components cannot be stored in MySQL. The database controls access and
// stores a component_key; this registry binds that key to compiled components.
const MechanicsSuppliersList = React.lazy(
  () => import('../module_mechanics/mechanics_SuppliersList')
);

const CosmeticsDashboardHome = React.lazy(
  () => import('../module_cosmetics/cosmetics_homedash')
);

const normalize = (value) => String(value || '')
  .trim()
  .toLowerCase()
  .replace(/[^a-z0-9]/g, '');

/*
 * Add customer/application-specific forms here.
 *
 * Supported optional scopes:
 *   applicationIds: [4]
 *   applicationCodes: ['solar', 'ozcmis_v3']
 *   roles: ['admin_solar']
 *   shopIds: [58]
 *
 * More-specific scoped entries should be placed before general entries.
 */
export const SPECIAL_MENU_COMPONENTS = [
  {
    componentKey: 'RootControlCenter',
    canonicalId: 'rootcontrolcenter',
    roles: ['super_admin', 'superadmin'],
    component: RootControlCenter,
    componentProps: { embedded: true },
  },
  {
    componentKey: 'CosmeticsDashboardHome',
    canonicalId: 'dashboard',
    component: CosmeticsDashboardHome,
  },
  {
    componentKey: 'MechanicsSuppliersList',
    menuCodes: ['a_supplierslist', 'supplierslist', 'supplierlist'],
    canonicalId: 'supplierlist',
    component: MechanicsSuppliersList,
    componentProps: { embedded: true },
  },

  // Example customer-specific form:
  // {
  //   menuCodes: ['customer_58_special_report'],
  //   canonicalId: 'specialreport',
  //   shopIds: [58],
  //   applicationCodes: ['solar'],
  //   roles: ['admin_solar', 'manager_solar'],
  //   component: React.lazy(() => import('../module_solar/SpecialReport')),
  //   componentProps: { embedded: true },
  // },
];

const matchesScope = (entry, context) => {
  if (entry.applicationIds?.length
      && !entry.applicationIds.map(Number).includes(Number(context.applicationId))) return false;
  if (entry.applicationCodes?.length
      && !entry.applicationCodes.map(normalize).includes(normalize(context.applicationCode))) return false;
  if (entry.roles?.length
      && !entry.roles.map(normalize).includes(normalize(context.role))) return false;
  if (entry.shopIds?.length
      && !entry.shopIds.map(Number).includes(Number(context.shopId))) return false;
  return true;
};

export function resolveSpecialMenu(row, context = {}) {
  const componentKey = normalize(row?.component_key);
  if (componentKey) {
    const keyed = SPECIAL_MENU_COMPONENTS.find((entry) => (
      normalize(entry.componentKey) === componentKey && matchesScope(entry, context)
    ));
    if (keyed) return keyed;
  }
  const rowCodes = [row?.menu_code, row?.route, row?.menu_name].map(normalize).filter(Boolean);
  return SPECIAL_MENU_COMPONENTS.find((entry) => (
    matchesScope(entry, context)
    && (entry.menuCodes || []).map(normalize).some((code) => rowCodes.includes(code))
  )) || null;
}
